import { render, staticRenderFns } from "./TypeMenu.vue?vue&type=template&id=1b4657cf&scoped=true&"
import script from "./TypeMenu.vue?vue&type=script&lang=js&"
export * from "./TypeMenu.vue?vue&type=script&lang=js&"
import style0 from "./TypeMenu.vue?vue&type=style&index=0&id=1b4657cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4657cf",
  null
  
)

export default component.exports